<template lang="pug">
vm-prompt(vm-size="medium" @vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteRecordConfirm(form)" :vm-action="form.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="form.deleted_at" :vm-is-valid="!$v.form.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.form.$invalid },]")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-textarea(class="custom__note" height="100px" :placeholder='$t("purchase_orders.placeholder_justify")' v-model="form.justify" @keyup.enter="setBullets(form.notes)" type="text" :label='$t("purchase_orders.justify")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-select(:placeholder='$t("purchase_orders.supplier_placeholder")' :danger="$v.form.supplier_id.$invalid && $v.form.supplier_id.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.supplier_display') })" v-model="form.supplier_id" :label='$t("purchase_orders.supplier_display")')
          vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in catalog.suppliers")
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("purchase_orders.email_placeholder")' :danger="$v.form.email.$invalid && $v.form.email.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.email') })" v-model="form.email" :label='$t("purchase_orders.email")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group.separator
        vm-input(:placeholder='$t("purchase_orders.shipping_address_placeholder")' :danger="$v.form.shipping_address.$invalid && $v.form.shipping_address.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.shipping_address') })" v-model="form.shipping_address" :label='$t("purchase_orders.shipping_address")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("purchase_orders.delivery_time_placeholder")' :danger="$v.form.delivery_time.$invalid && $v.form.delivery_time.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.delivery_time') })" v-model="form.delivery_time" :label='$t("purchase_orders.delivery_time")')
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-input(:placeholder='$t("purchase_orders.deadline_placeholder")' :danger="$v.form.deadline.$invalid && $v.form.deadline.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.deadline') })" v-model="form.deadline" :label='$t("purchase_orders.deadline")')
    vm-col(vm-justify="left", vm-align="center", vm-w=6)
      b-form-group.separator
        vm-select(:placeholder='$t("purchase_orders.freight_placeholder")' :danger="$v.form.freight.$invalid && $v.form.freight.$model" :danger-text="$t('validation.required', { attribute: $t('purchase_orders.freight') })" v-model="form.freight" :label='$t("purchase_orders.freight")')
          vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in freight")
    vm-col(vm-justify="left", vm-align="center", vm-w=6)
      b-form-group.div__quotation
        vm-input(v-if="Boolean(form.freight)" type="currency" :danger="$v.form.total_freight.$invalid && $v.form.total_freight.$model" :danger-text="$t('validation.required', { attribute: $t('quotations.total_freight') })" v-model="form.total_freight" :label='$t("quotations.total_freight")')
    vm-col(vm-justify="center", vm-align="center", vm-w=3)
      b-form-group.separator
        label.vm-input--label {{ $t('quotations.tax_type') }}
        .radio-section.d-flex
          .radio-item.margin-left
            input.radio-margin(type="radio" value=0 id="tax_0" v-model="form.tax_type")
            label.radio-label(for="tax_0") 0%
          .radio-item.margin-left
            input.radio-margin(type="radio" value=.08 id="tax_8" v-model="form.tax_type")
            label.radio-label(for="tax_8") 8%
          .radio-item.margin-left
            input.radio-margin(type="radio" value=.16 id="tax_16" v-model="form.tax_type")
            label.radio-label(for="tax_16") 16%
    vm-col(vm-justify="center", vm-align="center", vm-w=6)
      b-form-group.separator
        label.vm-input--label {{ $t('quotations.currency') }}
        .radio-section.d-flex.margin-left
          .radio-item(v-for='(currency, index) in catalog.currencies' :key="index")
            input(type="radio" :value="currency.id" :id="currency.id" v-model="form.currency_id")
            label.radio-margin(:for="currency.id") {{ currency.code }}
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      vm-textarea(class="custom__note" height="100px" :placeholder='$t("purchase_orders.notes")' v-model="form.notes" @keyup.enter="setBullets(form.notes)" type="text" :label='$t("purchase_orders.notes")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required, email, requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('PurchaseOrders')

export default {
  name: 'ModalPurchaseOrders',
  mixins: [ModalMixin1],
  data: () => ({
    freight: [
      {
        text: 'Si',
        value: 1
      },
      {
        text: 'No',
        value: 0
      }
    ]
  }),
  validations () {
    return {
      form: {
        supplier_id: {
          required
        },
        email: {
          required,
          email
        },
        shipping_address: {
          required
        },
        delivery_time: {
          required
        },
        deadline: {
          required
        },
        freight: {
          required
        },
        total_freight: {
          required: requiredIf(() => this.form.freight)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible', 'catalog'])
  },
  async created () {
    this.getCatalog()
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.form = {
        ...this.form,
        tax_type: this.form.tax_type,
        justify: this.form.justify
      }
      this.isAdd ? this.addRecord(this.form) : this.editRecord(this.form)
    },
    setBullets (payload) {
      const bullet = '•'
      this.form.notes = `${payload}${bullet} `
    }
  }
}
</script>
